class SubgroupProductGrid extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.hasFilter = this.dataset.hasSubgroupFilter === "true";
    this.revealBatchSize = 12;
    this.revealedCount = 0;
    this.selectedSubgroups = [];

    this.productContainer = this.querySelector("[data-product-container]");
    this.revealBtn = this.querySelector("[data-reveal-more]");
    this.emptyState = this.querySelector("[data-empty-state]");
    this.loadingNote = this.querySelector("[data-loading-note]");
    this.sortSelect = this.querySelector("[data-subgroup-sort]");
    this.checkboxes = [...this.querySelectorAll("[data-subgroup-checkbox]")];

    if (!this.productContainer) return;

    this.totalPages = Number(this.productContainer.dataset.totalPages) || 1;
    this.collectCards();
    this.revealNext();

    this.revealBtn && this.revealBtn.addEventListener("click", () => this.revealNext());
    this.sortSelect && this.sortSelect.addEventListener("change", () => this.handleSortChange());
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => this.handleFilterChange());
    });

    if (this.totalPages > 1) {
      this.loadRemainingPages(2);
    }
  }

  collectCards() {
    this.allCards = [...this.productContainer.querySelectorAll(".m-product-item")];
    this.allCards.forEach((card) => card.classList.add("m:hidden"));
  }

  getMatchingCards() {
    if (this.selectedSubgroups.length === 0) return this.allCards;
    return this.allCards.filter((card) => {
      const cardSubgroups = (card.dataset.subgroups || "").split(",").filter(Boolean);
      return this.selectedSubgroups.some((handle) => cardSubgroups.includes(handle));
    });
  }

  revealNext() {
    const matchingCards = this.getMatchingCards();
    const nextBatch = matchingCards.slice(this.revealedCount, this.revealedCount + this.revealBatchSize);
    nextBatch.forEach((card) => card.classList.remove("m:hidden"));
    this.revealedCount += nextBatch.length;
    this.toggleRevealButton(matchingCards);
    this.toggleEmptyState(matchingCards);
  }

  toggleRevealButton(matchingCards) {
    if (!this.revealBtn) return;
    const hasMore = this.revealedCount < matchingCards.length;
    this.revealBtn.classList.toggle("m:hidden", !hasMore);
  }

  toggleEmptyState(matchingCards) {
    if (!this.emptyState) return;
    this.emptyState.classList.toggle("m:hidden", matchingCards.length > 0);
  }

  handleFilterChange() {
    this.selectedSubgroups = this.checkboxes.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
    this.allCards.forEach((card) => card.classList.add("m:hidden"));
    this.revealedCount = 0;
    this.revealNext();
  }

  handleSortChange() {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", this.sortSelect.value);
    window.location.href = url.toString();
  }

  loadRemainingPages(page) {
    if (page === 2) {
      this.classList.add("is-loading-products");
      this.checkboxes.forEach((checkbox) => (checkbox.disabled = true));
      this.loadingNote && this.loadingNote.classList.remove("m:hidden");
    }

    if (page > this.totalPages) {
      this.finishLoadingRemainingPages();
      return;
    }

    fetchSection(this.sectionId, { params: { page } })
      .then((dom) => {
        const newCards = dom.querySelectorAll("[data-product-container] .m-product-item");
        newCards.forEach((card) => {
          card.classList.add("m:hidden");
          this.productContainer.appendChild(card);
          this.allCards.push(card);
        });
        this.loadRemainingPages(page + 1);
      })
      .catch((err) => {
        console.error("Failed to load remaining products for sub-group filtering.", err);
        this.finishLoadingRemainingPages();
      });
  }

  finishLoadingRemainingPages() {
    this.classList.remove("is-loading-products");
    this.checkboxes.forEach((checkbox) => (checkbox.disabled = false));
    this.loadingNote && this.loadingNote.classList.add("m:hidden");
    this.revealedCount = 0;
    this.allCards.forEach((card) => card.classList.add("m:hidden"));
    this.revealNext();
  }
}

customElements.define("subgroup-product-grid", SubgroupProductGrid);
